export default "__VITE_PUBLIC_ASSET__6f4df280__"